<template>
  <div class="animated fadeIn">
    <div class="row">
      <!-- <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <span class="title_head">Search Cards</span>
            <small></small>
          </div>
          <div class="card-body">
            <b-row>
              <b-col sm="3" v-if="is_admin === true">
                <b-form-group>
                  <label for="Company List"> Company List </label><br />
                  <model-list-select
                    :list="companylist"
                    option-value="company_id"
                    option-text="company_name"
                    v-model="selectcompany"
                    placeholder="Search Company Name"
                    @searchchange="searchcompany($event)"
                    @input="onSelectCompnay($event)"
                    style="
                      -webkit-text-fill-color: rgb(83, 108, 121) !important;
                      height: 30px !important;
                      border: 1px solid rgb(194, 207, 214);
                      min-height: 30px;
                      border-radius: 1px;
                      padding-top: 6px;
                    "
                    class="product-drop"
                  ></model-list-select>
                </b-form-group>
              </b-col>
              <b-col sm="3">
              <b-form-group>
                  <label for="name">From Date</label><br />
                  <date-picker
                    v-model="fromdate"
                    editable
                    lang="en"
                  ></date-picker>
                </b-form-group>
              </b-col>  

              <b-col sm="3">
                <b-form-group>
                  <label for="name">To Date </label><br />
                  <date-picker
                    v-model="todate"
                    editable
                    lang="en"
                  ></date-picker>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label for="name">Purchase Id</label><br />
                  <b-form-input
                    type="text"
                    placeholder="Enter Purchase  Id"
                    v-model="productunit"
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="2">
                <b-form-group>
                  <button
                    type="button"
                    v-if="pur_view === true"
                    style="margin-top: 24px; margin-left: 16%;"
                    class="btn btn-pill btn-primary serach_bttn"
                    @click="searchpurchase"
                  >
                    <i class="fa fa-search"></i>&nbsp;Search
                  </button>
                </b-form-group>
              </b-col>
            </b-row>
          </div>
        </div>
      </div> -->
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> List Schemes
          
                  <button
                      type="button"
                      class="btn btn-sm btn-primary label_bttn"
                      @click.prevent="addscheme()"
                    >
                      <i class="fa fa-plus"></i> Create Scheme
                    </button>
                </div>
                <!-- <div class="col-sm-8"> 
                  </div> -->
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                &nbsp;&nbsp;
                <div class="col-sm-1">
                  <button
                    id="MyDownload"
                    type="button"
                    v-if="pur_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                    hidden
                  >
                    <i class=""></i> Export Data
                  </button>
                </div>
              </div>
            </div>
            <!-- <span class="title_head"
              >List Purchase
              <span
                >&nbsp;&nbsp;
                <a href="#/Purchase/AddPurches" v-if="pur_rights === true"
                  ><button
                    type="button"
                    class="btn btn-sm btn-primary label_bttn"
                  >
                    <i class="fa fa-plus"></i> Add Purchase
                  </button></a
                >
              </span>
              <span
                >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <button  id = 'MyDownload'
                   type="button"
                    v-if="pur_view === true"
                    class="btn btn-sm btn-primary label_bttn"
                    @click="exportData"
                  >
                    <i class="fa fa-plus"></i> Export Data
                    
                  </button>
              </span>
            </span> -->
          </div>
          <div class="card-body">
            <vue-good-table
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :columns="columns4"
              :rows="rows4"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  
                  <!-- <i
                    class="fa fa-eye"
                    @click="viewCard(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i> -->
                  <span v-if="pur_rights === true">
                     <i
                      class="fa fa-pencil"
                      style="color: #63c2de; font-size: 20px; cursor: pointer;"
                      title="Edit Scheme"
                      v-on:click="editScheme(props.row)"
                    ></i>
                    <i
                      class="fa fa-trash-o"
                      style="color: #f44336; font-size: 20px; cursor: pointer;"
                      title="Delete"
                      v-on:click="removeScheme(props.row)"
                    ></i>

                    <!-- <router-link :to="{ name: 'Edit Purchase', params: { purchaseId: props.row.purchase_id, shopId: props.row.est_shop_id }}"> -->
                   
                    <!-- </router-link> -->
                    <!--<a @click="editpro2(props.row)" style="color:#63c2de;font-size: 20px; cursor: pointer;">Return</a>-->
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-trash"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <i
                      class="fa fa-pencil"
                      style="color: grey !important; font-size: 20px;"
                    ></i>
                    <!--<a style="color:grey !important;font-size: 20px;">Return</a>-->
                  </span>
                </span>
                <span v-else-if="props.column.field == 'gst_total'">
                  {{
                    (
                      parseFloat(props.row.cgst_amt) +
                      parseFloat(props.row.sgst_amt) +
                      parseFloat(props.row.igst_amt)
                    ).toFixed(2)
                  }}
                </span>

                <span v-else-if="props.column.field == 'lastupdated_datetime'">
                  {{ newDate(props.row.lastupdated_datetime) }}
                </span>
                <span v-else-if="props.column.field == 'return'">
                  <span v-if="pur_rights === true">
                    <i
                      class="fa fa-reply"
                      style="color: #63c2de; font-size: 18px; cursor: pointer;"
                      v-on:click="editpro2(props.row)"
                    ></i>
                  </span>
                  <span v-else>
                    <i
                      class="fa fa-reply"
                      style="color: grey !important; font-size: 18px;"
                    ></i>
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      title="Card detail "
      no-close-on-esc
      no-close-on-backdrop
      size="lg"
      hide-footer
      class="modal-warning"
      v-model="warningModal"
      @ok="warningModal = true"
      ok-variant="warning"
    >
      <b-collapse id="collapse1" visible>
        <vue-good-table
          :columns="columns"
          :rows="rows"
          mode="remote"
          ref="my-table1"
          @on-page-change="onPageChange1"
          @on-sort-change="onSortChange1"
          @on-column-filter="onColumnFilter1"
          @on-per-page-change="onPerPageChange1"
          :totalRows="totalRecords1"
          :pagination-options="{ enabled: true, perPage: 10 }"
          styleClass="vgt-table striped bordered table-sm condensed"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'tax_inclusive'">
              <div v-if="props.row.tax_inclusive == true">Inclusive</div>
              <div v-else>Exclusive</div>
            </span>

            <span v-else-if="props.column.field == 'gst_total'">
              {{
                (
                  parseFloat(props.row.cgst_amt) +
                  parseFloat(props.row.sgst_amt) +
                  parseFloat(props.row.igst_amt)
                ).toFixed(2)
              }}
            </span>

            <span v-else>
              {{ props.formattedRow[props.column.field] }}
            </span>
          </template>
        </vue-good-table>
      </b-collapse>
    </b-modal>

    <b-modal :title="tit" no-close-on-esc no-close-on-backdrop size="lg" class="modal-info" hide-footer v-model="largeModal" @ok="largeModal = false">
      <b-row>
          <b-col sm="6">
              <b-form-group>
                <label for="name"> Scheme Name </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Scheme Name"
                  autocomplete="off"
                  v-model="cardData.schemename"
                ></b-form-input>
                <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.schemename}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name"> Monthly Pay </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Monthly Pay"
                  autocomplete="off"
                  v-model="cardData.monthlypay"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.monthlypay}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name"> Months </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Number of Months"
                  autocomplete="off"
                  v-model="cardData.schememonths"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.schememonths}}</strong></small>
              </b-form-group>
            </b-col>
             <b-col sm="6">
              <b-form-group>
                <label for="name"> Bonus Months </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Number of Bonus Months"
                  autocomplete="off"
                  v-model="cardData.schemebonusmonths"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.schemebonusmonths}}</strong></small>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <label for="name">Shop Contribution (Months)</label>
                <b-form-input
                  type="text"
                  placeholder="Enter Number of Months"
                  autocomplete="off"
                  v-model="cardData.schemefirmbonusmonths"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.schemebonusmonths}}</strong></small>
              </b-form-group>
            </b-col>
              <b-col sm="6">
              <b-form-group>
                <label for="name"> Scheme reference benefit in % (optional) </label>
                <b-form-input
                  type="text"
                  placeholder="Enter Percentage"
                  autocomplete="off"
                  v-model="cardData.schemerefbenifit"
                ></b-form-input>
                 <small  class="form-text text-muted"><strong style="color: red;">{{hasErrors.schemerefbenifit}}</strong></small>
              </b-form-group>
            </b-col>
      </b-row>
      <div class="card-footer modal_footer">
        <b-row>
          <b-col sm="12">
            <b-button-group>
              <b-button class="d-sm-down-none btn-sm" v-if="saveBtn" @click.prevent="cardScheme()" variant="primary"><i class="fa fa-dot-circle-o"></i> Save</b-button>
               <b-button class="d-sm-down-none btn-sm" v-if="editBtn" @click.prevent="editSchemedata()" variant="primary"><i class="fa fa-dot-circle-o"></i> Edit</b-button>
            </b-button-group>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  name: "Cardlist",
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      tit:'',
      saveBtn:false,
      editBtn:false,
      scheme_id:'',
      companylist: [],

      selectcompany: null,
      pfrst_time: false,
      shpfrst_time: false,
      productunit: "",
      productqty: "",
      rows: [],
      rows1: [],
      rows2: [],
      rows4: [],
      todate: "",
      fromdate: "",
      temprow: null,
      warningModal: false,
      warningModal1: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
       hasErrors:{
          schemename:'',
          monthlypay:'',
          schememonths:'',
          schemebonusmonths:'',
          schemefirmbonusmonths:'',
          schemerefbenifit:''
        },
         cardData:{
          schemename:'',
          monthlypay:'',
          schememonths:'',
           schemebonusmonths:'',
           schemefirmbonusmonths:'',
            schemerefbenifit:'0'
        },
      serverParams: {
        columnFilters: {},
        sort: {
          field: "purchase_id",
          type: "asc",
        },
        page: 1,
        perPage: 5,
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      totalRecords1: 0,
      totalRecords2: 0,
       columns4: [
        {
          label: "Scheme Id",
          field: "scheme_id",
          width: "10% !important",
          thClass: "text-center",
        },
        {
          label: "Scheme Name",
          field: "scheme_name",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Monthly Pay",
          field: "monthly_pay",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Months",
          field: "scheme_months",
          width: "15% !important",
          thClass: "text-center",
        },
        
        {
          label: "Date",
          field: "lastupdated_datetime",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-center",
          width: "15% !important",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "Return",
        //   field: "return",
        //   width: "5% !important",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
      columns1: [
        {
          label: "Product Name",
          field: "product_name",
          width: "25% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "15% !important",
        },
        {
          label: "Qty",
          field: "purchase_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "8% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Barcode",
          field: "item_barcode",
          width: "32% !important",
        },
      ],

      columns2: [
        {
          label: "Product Name",
          field: "product_name",
          width: "25% !important",
        },
        {
          label: "Variant",
          field: "variant_id",
          width: "15% !important",
        },
        {
          label: "Qty",
          field: "purchase_qty",
          width: "10% !important",
        },
        {
          label: "Price",
          field: "product_unit_cost",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Sub Total",
          field: "sub_total",
          width: "10% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Tax",
          field: "tax_inclusive",
          width: "8% !important",
        },
        {
          label: "GST%",
          field: "gst_total",
          width: "15% !important",
        },
        {
          label: "Amount",
          field: "amt_to_pay",
          width: "15% !important",
          formatFn: this.formatFn,
        },
        {
          label: "Return Qty",
          field: "return_qty",
          width: "15% !important",
        },
        {
          label: "Barcode",
          field: "item_barcode",
          width: "32% !important",
        },
      ],

       columns: [
        {
          label: "Card Id",
          field: "id",
          width: "10% !important",
          thClass: "text-center",
        },
        {
          label: "Ledger No",
          field: "ledger_no",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Monthly Pay",
          field: "monthly_pay",
          width: "15% !important",
          thClass: "text-center",
        },
        {
          label: "Opening Month",
          field: "opening_month",
          width: "15% !important",
          thClass: "text-center",
        },
        
        {
          label: "Date",
          field: "lastupdated_datetime",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-center",
          width: "15% !important",
        },
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-center",
          tdClass: "text-center",
        },
        // {
        //   label: "Return",
        //   field: "return",
        //   width: "5% !important",
        //   tdClass: "text-center",
        //   thClass: "text-center",
        // },
      ],
    };
  },
  computed: {
    
    pur_view: function () {
      if (this.$store.getters.get_is_admin !== true) {
        if (this.$store.getters.get_pur_view === true) {
          this.purchase("comp");
          this.shopuser("comp");
          this.goldScheme()
          
          return true;
        } else {
          return false;
        }
      }
    },
    pur_rights: function () {
      return this.$store.getters.get_pur_rights;
    },
    is_admin: function () {
      return this.$store.getters.get_is_admin;
    },
  },

  // created(){
  //       this.purchase();
  //       this.shopuser();
  //   },

  methods: {
    cardScheme(){ 
        var _this = this
      //  this.haserrors.message=''
        
        this.submit_true=0;
        //this.onComplete('check')
        // var formData = new FormData();
        // _this.hasErrors.brandlogo=false;
        // const fileInput = document.querySelector('#image');
      if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
           if(_this.cardData.schemename==null || _this.cardData.schemename=='' ){
              _this.loading=false;
            this.hasErrors.schemename="Please Enter Scheme Name"
          }else if(_this.cardData.schememonths  ==null || _this.cardData.schememonths==''){
               _this.loading=false;
              _this.hasErrors.schememonths="Please Enter No of Months"
              }else if(_this.cardData.schemebonusmonths  ==null || _this.cardData.schemebonusmonths ==''){
               _this.loading=false;
              _this.hasErrors.schemerefbenifit ="Please Enter Months"
              }else{
                 var user=null;
            _this.submitschemevalue(_this)
              }
         
             }
          },
            submitschemevalue(_this){
              
                      let res = {
                          monthly_pay:this.cardData.monthlypay,
                          scheme_months:this.cardData.schememonths,
                          scheme_name:this.cardData.schemename,    
                          scheme_bonus_months:this.cardData.schemebonusmonths,   
                          scheme_firm_bonus_months:this.cardData.schemefirmbonusmonths,
                          scheme_ref_benifit:this.cardData.schemerefbenifit                     
                        }

                this.$http.post('/api/goldschemes', res)
                .then(function (response) {
              
                  
               if(response.status==200){
                _this.message = true
                 _this.message = "Scheme Added Successfully"
                 _this.largeModal = false;
                 alert("Scheme Added Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.goldScheme();
                // _this.getTotals();
                  
                  _this.reset();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
          addscheme(){
            this.reset();
            //  this.hasErrors.schemename=false
            //  this.hasErrors.monthlypay=false
            //  this.hasErrors.schememonths=false
            this.saveBtn = true
            this.editBtn = false
            this.tit = "Add Scheme"
            this.largeModal = true
            
          },
          editSchemedata(){ 
          var _this = this        
          this.submit_true=0;
          if (this.submit_true==0){
          this.loading=true
          //this.largeModal=false;
           if(_this.cardData.schemename==null || _this.cardData.schemename=='' ){
              _this.loading=false;
            this.hasErrors.schemename="Please Enter Scheme Name"
          }else if(_this.cardData.schememonths  ==null || _this.cardData.schememonths==''){
               _this.loading=false;
              _this.hasErrors.schememonths="Please Enter No of Months"
              }else if(_this.cardData.schemebonusmonths  ==null || _this.cardData.schemebonusmonths ==''){
               _this.loading=false;
              _this.hasErrors.schemerefbenifit ="Please Enter Months"
              }else{
                 var user=null;
            _this.submitschemevalue1(_this)
              }
             }
          },
          submitschemevalue1(_this){
              let res = {
                          monthly_pay:this.cardData.monthlypay,
                          scheme_months:this.cardData.schememonths,
                          scheme_name:this.cardData.schemename,  
                          scheme_bonus_months:this.cardData.schemebonusmonths,     
                          scheme_firm_bonus_months:this.cardData.schemefirmbonusmonths, 
                          scheme_ref_benifit:this.cardData.schemerefbenifit                 
                        }
                this.$http.post('/api/goldschemes/update?where[scheme_id]='+this.scheme_id, res)
                .then(function (response) {            
                if(response.status==200){
                _this.message = true
                 _this.message = "Scheme Edited Successfully"
                 _this.largeModal = false;
                 alert("Scheme Edited Successfully")
                 setTimeout(function(){ _this.message='';}, 2000);
                 _this.loading=false;
                  _this.goldScheme();
                
               }else{
                console.log('error')
               }
            
                })
                  .catch(function (error) {
                    _this.loading=false
                    console.log(error)
                  });

            },
    editScheme(schemeid){
      this.reset();
      this.saveBtn = false
      this.editBtn = true
      this.tit = "Edit Scheme"
      this.largeModal = true
      this.cardData.schemename = schemeid.scheme_name
      this.cardData.monthlypay = schemeid.monthly_pay
      this.cardData.schememonths = schemeid.scheme_months
      this.cardData.schemebonusmonths = schemeid.scheme_bonus_months
      this.cardData.schemefirmbonusmonths = schemeid.scheme_firm_bonus_months
      this.cardData.schemerefbenifit = schemeid.scheme_ref_benifit
      this.scheme_id = schemeid.scheme_id
    },
    reset(){
      this.cardData.schemename = ''
      this.cardData.monthlypay = ''
      this.cardData.schememonths = ''
      this.cardData.schemerefbenifit=''
      this.cardData.schemebonusmonths = ''
      this.hasErrors.schemename = ''
      this.hasErrors.monthlypay = ''
      this.hasErrors.schememonths = ''
      this.hasErrors.schemerefbenifit = ''
      this.hasErrors.schemebonusmonths = ''
    },
     viewCard(row) {
       
      this.rows.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      this.warningModal = true;
      var _this = this;
      this.temprow = row;
      // var data =[]
      var data = "&filter[where][card_id]=" + row.id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/customercards/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          // if (response.data != undefined) {
          //   _this.totalRecords1 = response.data[0].totalRecords;
          //   response.data.shift();
          //   _this.rows = response.data;
          //   //console.log(response.data)
          // }
          if (response.data == null) {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            alert(
              "Card id - " +
                row.id +
                " No Detail Found"
            );
          } else {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            _this.$router.props = [row.id];
            localStorage.setItem("card_id", JSON.stringify(row.id));
            _this.$router.push("/gold/carddetail");
          }
        });
    },
    newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;
      // var dt2 = year+'-'+month+'-'+day
      return dt2;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      this.loadItems();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      this.loadItems();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      this.loadItems();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      this.loadItems();
    },

    updateParams1(newProps) {
      this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
    },

    onPageChange1(params) {
      this.updateParams1({ page: params.currentPage });
      this.editpro(this.temprow);
    },

    onPerPageChange1(params) {
      this.updateParams1({ perPage: params.currentPerPage, page: 1 });
      this.editpro(this.temprow);
    },

    onSortChange1(params) {
      this.updateParams1({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field,
        },
        page: 1,
      });
      this.editpro(this.temprow);
    },

    onColumnFilter1(params) {
      this.updateParams1(params);
      this.editpro(this.temprow);
    },

    updateParams2(newProps) {
      this.serverParams2 = Object.assign({}, this.serverParams2, newProps);
    },

    onPageChange2(params) {
      this.updateParams2({ page: params.currentPage });
      this.editpro2(this.temprow);
    },

    onPerPageChange2(params) {
      this.updateParams2({ perPage: params.currentPerPage, page: 1 });
      this.editpro2(this.temprow);
    },

    onSortChange2(params) {
      this.updateParams2({
        sort: {
          type: params.sortType,
          field: this.columns1[params.columnIndex].field,
        },
        page: 1,
      });
      this.editpro2(this.temprow);
    },

    onColumnFilter2(params) {
      this.updateParams2(params);
      this.editpro2(this.temprow);
    },

    // editPurchase(row){
    //    var _this = this
    //    var filteParam = {};
    //    filteParam.pid = this.row.purchase_id;
    //    filteParam.sid = this.row.est_shop_id;

    // },

   
   

    searchcompany(searchText) {
      var _this = this;
      this.$http
        .get(
          "/api/companies?filter[where][company_name][ilike]=%" +
            searchText +
            "%"
        )
        .then(function (response) {
          // console.log(response)
          _this.companylist = response.data;
        })
        .catch(function (error) {});
    },

    onSelectCompnay(selected_company) {
      this.loadItems();
    },

    loadItems() {
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;

      if (this.todate && this.fromdate) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]= " +
          fromdate1 +
          "  &filter[where][lastupdated_datetime][between][1]= " +
          todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      if (this.productunit) {
        data = data + "&filter[where][purchase_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }

      this.$http
        .get(
          "/api/purchasedetails/getPurchase?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.totalRecords = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) _this.rows = response.data;
          _this.loading = false;
          // console.log(_this.rows)
        })
        .catch(function (error) {
          console.log(error);
          _this.loading = false;
        });
    },

    shopuser(val) {
      if (val === "comp") {
        if (this.shpfrst_time === false) {
          this.shpfrst_time = true;
        } else {
          return;
        }
      }
      var _this = this;
      this.$http
        .get("/api/shopusers")
        .then(function (response) {})
        .catch(function (error) {
          if (error.response.status === 401) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
          if (
            error.response.data.error.message ===
            "Cannot read property 'cmpname' of null"
          ) {
            localStorage.clear();
            _this.$store.commit("SET_AUTH_USER", null);
            _this.$router.push("/");
          }
        });
    },
    formatFn(value) {
      return parseFloat(value).toFixed(2);
    },

    purchase(val) {
      if (val === "comp") {
        if (this.pfrst_time === false) {
          this.pfrst_time = true;
        } else {
          return;
        }
      }
      this.loadItems();
    },
     goldScheme(){
      var _this=this
      this.$http.get('/api/goldschemes/schemecard') .then(function (response) {
        _this.rows4 =response.data
      })
      .catch(function (error) {

      });
    },
    editpro(row) {
      this.warningModal = true;
      var filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      var _this = this;
      var data = "";
      this.temprow = row;
      data = data + " &filter[where][purchase_id]= " + row.purchase_id;
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      this.$http
        .get(
          "/api/purchasedetails/searchdb?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          _this.totalRecords1 = response.data[0].totalRecords;
          response.data.shift();
          if (response.data != undefined) {
            _this.rows1 = response.data;
          }
        });
    },

    editpro2(row) {
      var filteParam = {};
      filteParam.page = this.serverParams2.page;
      filteParam.perPage = this.serverParams2.perPage;
      filteParam.sort = this.serverParams2.sort;
      var _this = this;
      var data = "";
      this.temprow = row;
      this.loading = true;
      this.$http
        .post(
          "/api/salesadjustments/getPurchaseAdj?purchaseId=" +
            row.purchase_id +
            "&shp_id=" +
            row.est_shop_id
        )
        .then(function (response) {
          if (response.data.data !== null) {
            _this.loading = false;
            alert(
              "Purchase id - " +
                row.purchase_id +
                " belongs to Sale Adjustment, so cannot be return."
            );
          } else {
            data =
              data +
              " &filter[where][purchase_id]= " +
              row.purchase_id +
              "&filter[where][chk_return]=true";
            _this.$http
              .get(
                "/api/purchasedetails/searchdb?params=" +
                  JSON.stringify(filteParam) +
                  data
              )
              .then(function (response) {
                _this.loading = false;
                if (response.data === null) {
                  alert("Items not exist in inventory to return");
                } else {
                  if (response.data != undefined) {
                    _this.warningModal1 = true;
                    if ("pur_rt_dt" in response.data) {
                      _this.totalRecords2 = response.data.pur_dt.length;
                      var purchase_return_id =
                        response.data.pur_rt_dt[0]["purchase_return_id"];
                      var obj_rtitemseq = {};
                      var pur_data = response.data.pur_dt;
                      var pur_rt_dt = response.data.pur_rt_dt;
                      for (var i = 0; i < pur_rt_dt.length; i++) {
                        obj_rtitemseq[
                          parseInt(pur_rt_dt[i].item_seq)
                        ] = parseInt(pur_rt_dt[i].return_qty);
                      }
                      // console.log(obj_rtitemseq)

                      for (var j = 0; j < pur_data.length; j++) {
                        if (
                          parseInt(pur_data[j].item_seq_no) in obj_rtitemseq
                        ) {
                          pur_data[j]["return_qty"] =
                            obj_rtitemseq[pur_data[j].item_seq_no];
                          pur_data[j][
                            "purchase_return_id"
                          ] = purchase_return_id;
                        } else {
                          pur_data[j]["return_qty"] = 0;
                          pur_data[j][
                            "purchase_return_id"
                          ] = purchase_return_id;
                        }
                      }

                      _this.rows2 = pur_data;
                      for (var k = 0; k < _this.rows2.length; k++) {
                        if (
                          parseInt(_this.rows2[k].item_seq_no) in obj_rtitemseq
                        ) {
                          _this.$set(_this.rows2[k], "vgtSelected", true);
                        }
                      }
                    } else {
                      _this.rows2 = response.data;
                      _this.totalRecords2 = response.data.length;
                    }
                  }
                }
              });
          }
        })
        .catch(function (error) {
          _this.loading = false;
          console.log(error);
        });
    },

    //Nishith Changes For Excel Report
    exportData() {
      // alert('data')
      this.loading = true;
      var _this = this;
      var data = [];
      var num = /^[0-9]{1}$/;
      var filteParam = {};
      filteParam.page = this.serverParams.page;
      filteParam.perPage = this.serverParams.perPage;
      filteParam.sort = this.serverParams.sort;
      var dateto = new Date(this.todate);
      var year = dateto.getFullYear();
      var month = dateto.getMonth() + 1;
      var day = dateto.getDate();
      if (num.test(month) == true) {
        var month = "0" + month;
      } else {
        var month = month;
      }

      if (num.test(day) == true) {
        var day = "0" + day;
      } else {
        var day = day;
      }

      var datefrom = new Date(this.fromdate);
      var year1 = datefrom.getFullYear();
      var month1 = datefrom.getMonth() + 1;
      var daycon = datefrom.getDate();
      if (num.test(month1) == true) {
        var month1 = "0" + month1;
      } else {
        var month1 = month1;
      }

      if (num.test(daycon) == true) {
        var day1 = "0" + daycon;
      } else {
        var day1 = daycon;
      }

      var todate1 = year + "-" + month + "-" + day;
      var fromdate1 = year1 + "-" + month1 + "-" + day1;
      var unit = this.productunit;
      var qty = this.productqty;

      if (this.todate && this.fromdate) {
        data =
          data +
          " &filter[where][lastupdated_datetime][between][0]= " +
          fromdate1 +
          "  &filter[where][lastupdated_datetime][between][1]= " +
          todate1;
      } else {
        if (this.todate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + todate1;
        }
        if (this.fromdate != "") {
          data = data + "&filter[where][lastupdated_datetime]=" + fromdate1;
        }
      }
      if (this.productunit) {
        data = data + "&filter[where][purchase_id]=" + unit;
      }
      if (this.selectcompany !== null) {
        data =
          data +
          "&filter[where][company_id]=" +
          this.selectcompany.company_id +
          "&filter[where][user_id]=" +
          this.selectcompany.cmp_email +
          "&filter[where][regcity]=" +
          this.selectcompany.regcity_code;
      }
      if(this.rows.length > 0 ){

      this.$http
        .get(
          "/api/purchasedetails/getPurchaseExport?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {
          // console.log(response)

          var access_token = localStorage.getItem("authUser");
          //  console.log(response.data)
          var url1 =
            _this.baseURL2 +
            "/api/containers/csv/download/" +
            response.data +
            "?access_token=" +
            access_token;
          // console.log('url  '  + url1)
          _this.loading = false;
          _this
            .$http({
              url: url1,
              method: "GET",
              responseType: "blob",
            })
            .then((res) => {
              const url = window.URL.createObjectURL(new Blob([res.data]));
              const link = document.createElement("a");
              link.setAttribute("download", response.data);
              link.href = url1;
              document.body.appendChild(link);
              link.click();
              _this.loading = false;
            });
          ///End OF Exce Downlod Method...
        });
      } else {
        _this.loading = false;
        alert('No Data Found')
      }
    },

    searchpurchase() {
      this.updateParams({
        sort: {
          type: "",
          field: "",
        },
        page: 1,
      });
      this.$refs["my-table"].reset();
      this.loadItems();
    },

     removeScheme(schemeid){
            var r = confirm("Are you sure you want to delete?");
            if (r == true) {
              this.loading=true
              var _this=this
              var _vm = this.errorMessage
              var id =schemeid.id;
              this.$http.delete('/api/goldschemes/'+id).then(function (response) {
                _this.loading=false
               // _vm.message = "Scheme Deleted Successfully"
                setTimeout(function(){ _vm.message='';}, 2000);
               // _this.getTotals();
                  _this.goldScheme();
                  
              })
              .catch(function (error) {
                _this.loading=false
                console.log(error);
              });
            }
          },

    editPurchase(row) {
      var _this = this;
      this.loading = true;
      this.$http
        .post(
          "/api/salesadjustments/getPurchaseAdj?purchaseId=" +
            row.purchase_id +
            "&shp_id=" +
            row.est_shop_id
        )
        .then(function (response) {
          _this.loading = false;
          if (response.data.data !== null) {
            alert(
              "Purchase id - " +
                row.purchase_id +
                " belongs to Sale Adjustment, so cannot be edited"
            );
          } else {
            _this.$router.push({
              name: "Edit Purchase",
              params: { purchaseId: row.purchase_id, shopId: row.est_shop_id },
            });
          }
        })
        .catch(function (error) {
          // _this.$router.push({ name: 'Edit Purchase', params: { 'purchaseId': row.purchase_id, 'shopId': row.est_shop_id }})
        });
    },

    // return_pur(row){
    //   var _this = this
    //   this.loading = true
    //   this.$http.post('/api/estshopinventories/checkItemsExistToReturn?filter[where][purchase_id]='+row.purchase_id+'&filter[where][est_shop_id]='+row.est_shop_id).then(function(response) {
    //       if(response.data.data != null){
    //         setTimeout(function(){ _this.loading = false}, 2000);
    //         alert('Purchase id - ' + row.purchase_id + ' - items not exist in Inventory')
    //       }
    //       else{
    //         _this.editpro2(row)
    //       }
    //      }).catch(function(error){
    //       // _this.$router.push({ name: 'Edit Purchase', params: { 'purchaseId': row.purchase_id, 'shopId': row.est_shop_id }})
    //   })
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/gold/goldscheme.vue